<template>
  <div>
    <!-- Image Fullscreen Preview -->
    <v-dialog v-model="show" max-width="466" persistent>
      <v-card max-width="466" color="greyColorLigthTwo" class="rounded-lg pt-4">
        <v-card-title class="defaultColor--text font-weight-bold mb-2"
          >İlan Ekle</v-card-title
        >
        <!-- Forms -->
        <v-card-text>
          <v-select
            v-model="selectedCategory"
            :items="categoryItems"
            color="defaultColor"
            hide-details
            class="mb-4"
            item-text="text"
            outlined
            full-width
            item-value="value"
            :label="$t('labels.selectCategory')"
            persistent-hint
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t("description.noContent") }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
          <v-text-field
            v-model.trim="title"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertTitle')"
            class="mb-5"
          >
          </v-text-field>
          <v-text-field
            v-model.trim="price"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertPrice')"
          >
          </v-text-field>
          <v-text-field
            class="pt-5"
            v-model.trim="city"
            outlined
            color="default-Color"
            hide-details
            single-line
            full-width
            :label="$t('labels.advertCity')"
          >
          </v-text-field>
          <v-textarea
            class="pt-5"
            outlined
            v-model.trim="content"
            full-width
            color="purple"
            :label="$t('labels.advertDescription')"
            :counter="contentCounter"
            rows="4"
          ></v-textarea>
          <v-textarea
            class="pt-2"
            outlined
            v-model.trim="contact"
            full-width
            color="purple"
            :label="$t('labels.advertContactInformation')"
            :counter="contactCounter"
            rows="3"
          >
            <template v-slot:append>
              <v-tooltip bottom max-width="400" color="defaultColorLight">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    fab
                    depressed
                    width="20"
                    height="20"
                    dark
                    small
                    color="defaultColor"
                  >
                    <v-icon dark size="12"> mdi-help </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("description.advertContactInfo") }}</span>
              </v-tooltip>
            </template>
          </v-textarea>
        </v-card-text>

        <!-- Photo -->
        <v-card-text v-if="uploadLoading">
          <loading-progress :status="uploadLoading" />
        </v-card-text>
        <v-card-text>
          <v-banner
            single-line
            shaped
            class="mt-0 pa-0"
            v-if="selectedFiles.length > 0"
          >
            <v-col class="mt-0 pa-0">
              <v-container class="mt-0 pa-0" mx-0 px-0 fluid grid-list-xl>
                <v-layout row wrap class="pa-0" v-if="!uploadLoading">
                  <v-flex
                    xs2
                    v-for="(item, index) in selectedFiles"
                    :key="index"
                  >
                    <v-hover>
                      <v-img
                        style="border-radius: 8px"
                        width="100%"
                        :aspect-ratio="1 / 1"
                        slot-scope="{ hover }"
                        contain
                        :src="
                          item.ThumbnailUrl
                            ? item.ThumbnailUrl
                            : item.LocalUrl
                            ? item.LocalUrl
                            : require('@/../public/images/ThumbVideo.png')
                                .default
                        "
                      >
                        <v-expand-transition>
                          <div
                            v-if="hover"
                            class="transition-fast-in-fast-out image-hover white--text"
                            style="height: 100%"
                          >
                            <v-layout
                              row
                              wrap
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    @click="deleteFile(item.id, index)"
                                    class="ma-0"
                                    icon
                                    v-on="on"
                                    style="z-index: 100"
                                  >
                                    <v-icon color="defaultColor"
                                      >mdi-close</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>{{ $t("buttons.delete") }}</span>
                              </v-tooltip>

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    class="ma-0"
                                    icon
                                    v-on="on"
                                    style="z-index: 100"
                                  >
                                    <v-icon color="defaultColor"
                                      >mdi-folder</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>{{ item.FileName }}</span>
                              </v-tooltip>
                            </v-layout>
                          </div>
                        </v-expand-transition>
                      </v-img>
                    </v-hover>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-col>
            <v-col
              align-self="end"
              class="pa-0 defaultColor--text"
              style="text-align: end; font-size: 12px; letter-spacing: 0px"
              v-if="selectedFiles.length > 0"
            >
              {{ fileLength == null ? " " : fileLength + " / " + "3" }}
            </v-col>
          </v-banner>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions -->
        <v-card-actions class="py-5">
          <input
            type="file"
            accept="image/png, image/jpeg"
            ref="fileInput"
            style="display: none"
            @change="selectFileHandle"
          />
          <v-btn
            color="defaultColorLight"
            class="text-capitalize"
            rounded
            elevation="0"
            dark
            :disabled="fileLength == 3"
            @click="browseFile"
          >
            <v-icon left dark flat> mdi-image-outline </v-icon>
            {{ $t("buttons.addPhoto") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="defaultColor"
            class="white--text text-capitalize"
            text
            rounded
            @click="closeModal"
          >
            {{ $t("buttons.cancelUpper") }}
          </v-btn>

          <v-btn
            color="defaultColor"
            class="white--text text-capitalize"
            elevation="0"
            text
            @click="createPost()"
            :loading="shareLoading"
          >
            {{ $t("buttons.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-btn
        @click="show = !show"
        height="50"
        dark
        class="mr-5 mb-4 px-0"
        elevation="0"
        color="defaultColorLightTwo"
        min-width="50"
        bottom
        right
        rounded
        fixed
      >
        <v-icon class="px-0">mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import PostService from "../../services/PostService";
import ContentService from "../../services/ContentService";
import LoadingProgress from "../General/LoadingProgress.vue";
import { mapActions } from "vuex";

//TODO:  inputlar ayarlanıp servis tetiklenecek

export default {
  data() {
    return {
      show: false,
      title: "",
      content: "",
      price: "",
      city: "",
      contact: "",
      contactCounter: 200,
      contentCounter: 250,

      //Categories
      selectedCategory: "",

      //File modals
      selectedFiles: [],
      selectedFilesUrl: [],
      fileLength: null,
      tempFiles: [],
      fileIds: [],
      uploadLoading: false,

      shareLoading: false,
    };
  },
  props: {
    categoryItems: {
      type: Array,
      default: [],
      require: true,
    },
  },
  mounted() {},
  components: {
    LoadingProgress,
  },
  methods: {
    createPost() {
      if (
        this.content != "" &&
        this.title != "" &&
        this.selectedCategory != "" &&
        this.price != "" &&
        this.city != "" &&
        this.contact != ""
      ) {
        const body = {
          Content: this.content,
          Title: this.title,
          FileIds: this.fileIds,
          CategoryIds: [this.selectedCategory],
          GroupIds: [],
          Type: 1,
          Key: "ilanlar",
          Properties: [
            {
              Key: "fiyat",
              Value: this.price,
              DataType: "string",
              Name: "Fiyat",
            },
            {
              Key: "sehir",
              Value: this.city,
              DataType: "string",
              Name: "Şehir",
            },
            {
              Key: "iletisim_bilgisi",
              Value: this.contact,
              DataType: "string",
              Name: "İletişim Bilgisi",
            },
            {
              Key: "ilan_sahibi",
              Value: this.$store.state.user.Email,
              DataType: "string",
              Name: "İletişim Bilgisi",
            },
          ],
        };
        this.createPostService(body);
      } else {
        this.showInfo(this.$t("description.formControl"), "standart", "error");
      }
    },

    createPostService(body) {
      this.shareLoading = true;
      PostService.createPost(body)
        .then((res) => {
          this.$emit("addNewItem", res.data);
          this.closeModal();
          this.shareLoading = false;
          showSuccess(this.$t("description.successShareContent"));
        })
        .catch((err) => {
          console.log(err);
          showError(err);
          this.shareLoading = false;
        });
    },

    closeModal() {
      this.show = false;
      this.title = "";
      this.content = "";
      this.price = "";
      this.city = "";
      this.contact = "";
      this.contactCounter = 200;
      this.contentCounter = 250;

      //Categories
      this.selectedCategory = "";

      //File modals
      this.selectedFiles = [];
      this.selectedFilesUrl = [];
      this.fileLength = null;
      this.tempFiles = [];
      this.fileIds = [];
      this.uploadLoading = false;

      this.shareLoading = false;
    },

    browseFile() {
      this.$refs.fileInput.click();
    },

    selectFileHandle(e) {
      if (e.target.files[0] === undefined) {
      } else {
        if (e.target.files[0].size < 20000000) {
          this.uploadFileCall(e.target.files[0]);
        } else {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        }
      }
      e.target.value = "";
    },

    //File upload to service
    uploadFile(media, file) {
      console.log("updaload file : ", file);
      if (media === undefined) {
        console.log("Undefined media");
      } else if (media.type == "") {
        console.log("unsupportedMediaType");
      } else {
        this.selectedFiles.push(file);
        this.tempFiles.push(file);
        this.fileIds.push(file.Id);
        this.selectedFilesUrl.push(file.LocalUrl);
        this.fileLength = this.selectedFiles.length;
      }
    },

    //Return file url to send service
    computedUrl(file) {
      return URL.createObjectURL(file);
    },

    //File delete
    deleteFile(fileId, index) {
      this.selectedFiles.splice(index, 1);
      this.selectedFilesUrl.splice(index, 1);
      this.tempFiles.splice(index, 1);
      this.fileIds.splice(index, 1);
      this.fileLength = this.selectedFiles.length;
    },

    uploadFileCall(media) {
      if (media === undefined) {
        showWarning(this.$t("description.unexpected"));
      }
      if (
        media.type == "image/jpeg" ||
        media.type == "image/png" ||
        media.type == "video/mp4"
      ) {
        let formData = new FormData();
        formData.append("Files", media);
        formData.append("Type", "media");
        this.uploadLoading = true;
        ContentService.uploadFile(formData)
          .then((res) => {
            this.uploadFile(media, res.data[0]);
          })
          .catch((err) => {
            console.log(err);
            showError(err);
          })
          .then(() => {
            this.uploadLoading = false;
          });
      } else {
        showWarning(this.$t("description.unexpected"));
      }
    },

    ...mapActions(["getPosts", "setUpdateDialogItem"]),
  },
  computed: {},
  watch: {},
};
</script>
